import React, { useState } from "react";
import { Form, Input, Button, Card, message } from "antd";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import API_BASE from "../config/api";
import { GoogleLogin } from "@react-oauth/google";
import { clearStaleAdminMerchantModeFlag } from "../utils/adminMerchantMode";

const AdminLogin = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // 🔹 NORMAL LOGIN
  const onFinish = async (values) => {
    setLoading(true);
    try {
      const res = await axios.post(`${API_BASE}/adminLogin`, values);

      if (res.data.success) {
        localStorage.setItem("admin_token", res.data.token);
        localStorage.setItem("user", JSON.stringify(res.data.data));
        // Fresh admin session — don't inherit a Merchant Mode flag left
        // over from a previous session that ended via plain Logout.
        clearStaleAdminMerchantModeFlag();

        message.success("Login successful");
        // 🔥 FIX: Force full app reload immediately after redirect
        setTimeout(() => {
          navigate("/admin/mode", { replace: true });
          window.location.reload(); // 🔥 This is the FIX
        }, 200);
        // navigate("/mode", { replace: true });
        // window.location.reload();
      } else {
        message.error(res.data.message);
      }
    } catch (err) {
      message.error(err.response?.data?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  // 🔹 GOOGLE LOGIN
  const handleGoogleLogin = async (googleRes) => {
    try {
      const res = await axios.post(`${API_BASE}/googleLogin`, {
        //  adminGoogleLogin`,   this is dynamic api googleLogin
        token: googleRes.credential,
      });

      if (res.data.success) {
        localStorage.setItem("admin_token", res.data.token);
        localStorage.setItem("user", JSON.stringify(res.data.data));
        // Fresh admin session — don't inherit a Merchant Mode flag left
        // over from a previous session that ended via plain Logout.
        clearStaleAdminMerchantModeFlag();

        message.success("Google login successful");
        navigate("/admin/login-as-merchant", { replace: true });
        window.location.reload();
      }
    } catch (err) {
      message.error(err.response?.data?.message || "Google login failed");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #1e3c72, #2a5298)",
      }}
    >
      <Card
        style={{
          width: 360,
          borderRadius: 12,
          boxShadow: "0 15px 40px rgba(0,0,0,0.25)",
          textAlign: "center",
        }}
        bordered={false}
      >
        {/* Logo / Title */}
        <h2 style={{ marginBottom: 8 }}>Admin Panel</h2>
        <p style={{ color: "#777", marginBottom: 24 }}>Sign in to continue</p>

        {/* Google Login */}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <GoogleLogin
            onSuccess={handleGoogleLogin}
            onError={() => message.error("Google login failed")}
          />
        </div>

        {/* Footer text */}
        <div style={{ marginTop: 24, fontSize: 12, color: "#999" }}>
          Only authorized admins can access
        </div>
      </Card>
    </div>
  );

  // return (
  //    <div
  //     className="loginBgs"
  //   >
  //     <Card title="Admin Login" style={{ width: 320 }}>
  //        <Form className="formPad" layout="vertical" onFinish={onFinish}>
  //         <Form.Item name="username" label="Username" rules={[{ required: true, message: "Please enter username" }]}>
  //           <Input />
  //         </Form.Item>

  //         <Form.Item name="password" label="Password" rules={[{ required: true, message: "Please enter password"  }]}>
  //           <Input.Password />
  //         </Form.Item>

  //         <Button type="primary" htmlType="submit" loading={loading} block>
  //           Login
  //         </Button>
  //       </Form>

  //       <div style={{ marginTop: 16, textAlign: "center",marginLeft: "24px" }}>
  //         <GoogleLogin
  //           onSuccess={handleGoogleLogin}
  //           onError={() => message.error("Google login failed")}
  //         />
  //       </div>
  //     </Card>
  //   </div>
  // );
};

export default AdminLogin;
